/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ app: NonNullable<unknown> }} Mcp_Connect_Permissions_LabelInputs */

const en_mcp_connect_permissions_label = /** @type {(inputs: Mcp_Connect_Permissions_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.app} will be able to:`)
};

const es_mcp_connect_permissions_label = /** @type {(inputs: Mcp_Connect_Permissions_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.app} podrá:`)
};

/**
* | output |
* | --- |
* | "{app} will be able to:" |
*
* @param {Mcp_Connect_Permissions_LabelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_connect_permissions_label = /** @type {((inputs: Mcp_Connect_Permissions_LabelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Connect_Permissions_LabelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_connect_permissions_label(inputs)
	return en_mcp_connect_permissions_label(inputs)
});